import { createFileRoute, redirect } from "@tanstack/react-router";

import {
  guardAgbwFeature,
  redirectToClientOverview,
} from "@/core/lib/feature-guards";

export const Route = createFileRoute(
  "/_protected/auditor/clients/$id/agbw-results",
)({
  beforeLoad: ({ context: { active }, location, params }) => {
    if (!guardAgbwFeature(active).allowed) {
      redirectToClientOverview(params.id);
    }

    // Redirect to overview if visiting the base agbw-results route
    const isBaseRoute =
      location.pathname.endsWith("/agbw-results") ||
      location.pathname.endsWith("/agbw-results/");

    if (isBaseRoute) {
      throw redirect({
        to: "/auditor/clients/$id/agbw-results/overview",
        params: { id: params.id },
      });
    }
  },
});
